<template>
  <div>
    <el-form-item :label="$t('登录部门')">
        <el-switch v-model="data.isLogin" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否多选')">
        <el-switch v-model="data.multiple" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否必填')">
        <el-switch v-model="data.required" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否只读')">
        <el-switch v-model="data.readonly"></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否可见')">
        <el-switch v-model="data.display"></el-switch>
    </el-form-item>
  </div>
</template>


<script>
import mixin from '../../../mixin'

export default {
  name: "config-departmentSelect",
  mixins: [mixin()],
  inject: {"formDesign":{
      default: () => ({ formInfo: { tabList: [] } }) // 提供默认值
    }},
  props: ['data'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

